import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

class StaffOJTsTab extends Component {

  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      staff_ojts: [],
    };
  }

  // LM
  componentWillReceiveProps(newProps) {
    if(Array.isArray(newProps.staff_ojts)) {
      this.setState({staff_ojts: newProps.staff_ojts});
    }
  }

  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <h3 className="page-title">OJTS</h3>
  <hr/>
  <table className="table table-bordered table-stripped table-hover">
    <thead>
      <tr>
        <th className="text-center">Tarefa</th>
        <th className="text-center">Data final</th>
        <th className="text-center">Função treinada</th>
        <th className="text-center">Ordem de serviço</th>
        <th className="text-center">Base</th>
        <th className="text-center">Satisfatório</th>
        <th className="text-center">Status</th>
      </tr>
    </thead>
    
    <tbody id="suppliers-certifications">
    {
      /*
      {Object.keys(self.state.staff_ojts).map(function(k) {
        return (
          <tr>
            <td className="text-center">{self.state.staff_ojts[k].ojt.name}</td>
            <td className="text-center">{self.state.staff_ojts[k].date_finish_str}</td>
            <td className="text-center">{self.state.staff_ojts[k].trained_role}</td>
            <td className="text-center">{self.state.staff_ojts[k].service_order}</td>
            <td className="text-center">{self.state.staff_ojts[k].base.name}</td>
            <td className="text-center">{self.state.staff_ojts[k].result}</td>
            <td className="text-center">
              {(self.state.staff_ojts[k].status_str == 'Aprovado') ? <span className="label label-success">{self.state.staff_ojts[k].status_str}</span> : '' }
              {(self.state.staff_ojts[k].status_str == 'Reprovado') ? <span className="label label-danger">{self.state.staff_ojts[k].status_str}</span> : '' }
              {(self.state.staff_ojts[k].status_str == 'Pendente') ? <span className="label label-warning">{self.state.staff_ojts[k].status_str}</span> : '' }
            </td>
          </tr>
        );
      })}
      
       */
    }
    </tbody>
  </table>
</div>
    );
  }
}

export default StaffOJTsTab;



// WEBPACK FOOTER //
// ./src/Components/SigmecStaffs/Elements/StaffOJTsTab.js